import { ProfileAttachment } from './profile-attachment.model';

export class Profile {

    // Constants
    static junkDateString = 'Wed Dec 31 1969 19:00:00 GMT-0500 (Eastern Standard Time)';
    static junkDate = new Date(Profile.junkDateString);

    // Server Properties
    '$id': string;
    AddedBy: number;
    AddedOn: string;
    Content: string;
    DateFromView = new Date(Profile.junkDateString);
    DateToView = new Date(Profile.junkDateString);
    DelBy = new Date(Profile.junkDateString);
    DelOn = new Date(Profile.junkDateString);
    DelStatus: boolean;
    Image: string;
    LastUpBy = new Date(Profile.junkDateString);
    LastUpOn = new Date(Profile.junkDateString);
    MemId: number;
    ParentID: number;
    ProfileAttachments?: ProfileAttachment[] = [];
    ProfileContentId: number;
    RecordType: number;
    RowId: number;
    SSECID: number;
    Sequence: number;
    Status: string;
    Title: string;
    TopicId: number;

    // Local Properties
    newSequence: number; // We use this to prevent data persistence of moving rows

    // Class Functions
    get SSEC_ID(): number {
        return this.SSECID;
    }

    set SSEC_ID(value: number) {
        this.SSECID = value;
    }

    get parentViewableAttachments() {
        return this.ProfileAttachments.filter(attachment => attachment.AllowParentToView);
    }

	get sequence(): number {
		return this.newSequence != undefined ? this.newSequence : this.Sequence;
	}

	set sequence(value: number) {
    	this.newSequence = value;
	}

    // Methods
    outsideOfDateRange() {
        // POST: returns true if this profile is currently within its date range
        return (this.DateFromView && this.DateFromView.toString() != Profile.junkDate.toString() && new Date() < this.DateFromView) ||
            (this.DateToView && this.DateToView.toString() != Profile.junkDate.toString() && new Date() > this.DateToView);
    }

    cleanJunkDates() {
        // POST: cleans the junk dates from the class information
        if (this.DateFromView && this.DateFromView.toString() == Profile.junkDate.toString()) {
            this.DateFromView = null;
        }
        if (this.DateToView && this.DateToView.toString() == Profile.junkDate.toString()) {
            this.DateToView = null;
        }
        if (this.DelBy && this.DelBy.toString() == Profile.junkDate.toString()) {
            this.DelBy = null;
        }
        if (this.DelOn && this.DelOn.toString() == Profile.junkDate.toString()) {
            this.DelOn = null;
        }
        if (this.LastUpBy && this.LastUpBy.toString() == Profile.junkDate.toString()) {
            this.LastUpBy = null;
        }
        if (this.LastUpOn && this.LastUpOn.toString() == Profile.junkDate.toString()) {
            this.LastUpOn = null;
        }
    }
}